<div class="tab-pane fade in" id="home">
    <div class="row" *ngIf='loader'>
        <app-sura-loader></app-sura-loader>
    </div>
    <div class="seguro" *ngIf='!loader'>
        <!-- CICLO FACTURACION-->
        <div class="row">
            <app-ciclo-facturacion [item]="seguro.facturacion"></app-ciclo-facturacion>
        </div>
        <div class="row">
            <div class="box-container">
                <div class="box-data-container">
                    <div class="box-contain a-start">
                        <!-- MES GASTADO-->
                        <app-mes-gastado [facturacion]='seguro.facturacion' [poliza]='seguro.poliza'></app-mes-gastado>
                        <!-- ULT UBICACION-->
                        <app-ult-ubicacion [item]='seguro.ultimaUbicacion'></app-ult-ubicacion>
                    </div>
                    <div class="box-contain a-start">
                        <!-- KM RECORRIDOS-->
                        <app-kms-recorridos [item]='seguro.mesAnterior'></app-kms-recorridos>
                        <!-- KM 6 MESES-->
                        <app-meses-recorridos [item]='seguro.seisMeses'></app-meses-recorridos>
                        <!-- DETALLE POLIZA-->
                        <app-detalle-poliza [poliza]='seguro.poliza' [facturacion]='seguro.facturacion'></app-detalle-poliza>
                    </div>

                    <!-- ASISTENCIAS-->
                    <app-asistencias [asistencias]='seguro.asistencias' [poliza]='seguro.poliza'></app-asistencias>
                </div>
                <div class="box-patente-container">
                    <!-- POLIZA-->
                    <app-poliza [item]='seguro.poliza'></app-poliza>
                </div>
            </div>
        </div>
    </div>
</div>
